import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ErrorHandlerService } from '@app/shared/services/error-handler.service';
import { catchError, throwError } from 'rxjs';

export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorHandler = inject(ErrorHandlerService);
  const skipErrorToastHeader = 'X-Skip-Error-Toast';
  const shouldSkipErrorToast = req.headers.has(skipErrorToastHeader);
  const request = shouldSkipErrorToast
    ? req.clone({ headers: req.headers.delete(skipErrorToastHeader) })
    : req;

  if (req.context.get(SKIP_ERROR_INTERCEPTOR)) {
    return next(req);
  }

  const excludedUrls = [
    '/auth/refresh',
    '/userActivity/registerWeb',
    '/global-configuration-platforms/code/MASK_SENSITIVE_FIELDS_ENABLED'
  ];

  const shouldExclude = excludedUrls.some(url => request.url.includes(url));

  if (shouldExclude) {
    return next(request);
  }

  return next(request).pipe(
    catchError((error) => {
      if (!shouldSkipErrorToast) {
        errorHandler.handleError(error);
      }
      return throwError(() => error);
    })
  );
};
